export const SET_FILES_TO_SHARE = 'SET_FILES_TO_SHARE';

export const SEND_SHARING_DATA_REQUEST = 'sharing/SEND_SHARING_DATA_REQUEST';
export const SEND_SHARING_DATA_SUCCESS = 'sharing/SEND_SHARING_DATA_SUCCESS';
export const SEND_SHARING_DATA_FAIL = 'sharing/SEND_SHARING_DATA_FAIL';

export const OPEN_SHARING_MODAL = 'OPEN_SHARING_MODAL';
export const CLOSE_SHARING_MODAL = 'CLOSE_SHARING_MODAL';